var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLockOpen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "79px",
    height: "76px",
    viewBox: "0 0 79.0 76.0",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "i0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.59378,0 C68.35938,0 78.17388,6.6895 78.17388,21.6309 L78.17388,29.1992 C78.17388,31.9824 76.66018,33.1055 74.75588,33.1055 C72.80278,33.1055 71.28908,31.836 71.28908,29.1992 L71.28908,20.6543 C71.28908,11.1817 65.13668,6.543 58.59378,6.543 C52.00198,6.543 45.89848,11.1817 45.89848,20.6543 L45.898,31.101 L46.0851901,31.1357786 C50.1930025,31.9300958 52.3036685,34.8141796 52.38983,39.95218 L52.39258,40.2832 L52.39258,66.01564 C52.39258,72.41213 49.41408,75.43947 43.50588,75.43947 L8.88668,75.43947 C2.97848,75.43947 0,72.41213 0,66.01564 L0,40.2832 C0,33.9356 2.97848,30.9082 8.88668,30.9082 L39.013,30.908 L39.01368,21.6309 C39.01368,6.838914 48.5849446,0.13461519 58.2993694,0.0020084124 Z M43.21288,37.4512 L9.17968,37.4512 C7.81248,37.4512 7.03128,38.1836 7.03128,39.7949 L7.03128,66.50392 C7.03128,68.11525 7.81248,68.8965 9.17968,68.8965 L43.21288,68.8965 C44.62888,68.8965 45.36138,68.11525 45.36138,66.50392 L45.36138,39.7949 C45.36138,38.1836 44.62888,37.4512 43.21288,37.4512 Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-917.3399999999999 -2.7089999999999463)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(918.0956199999998 2.7831999999999653)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i0)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 78.17388,0 78.17388,75.43947 0,75.43947 0,0",
    stroke: "none",
    fill: "#34C758"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockOpen);
export default __webpack_public_path__ + "static/media/lock_open.fdbc18619e6eb08068a5d16d66385140.svg";
export { ForwardRef as ReactComponent };